// pages/TravelPage.tsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import leftFlower from "../assets/leftFlower.png";
import rightFlower from "../assets/rightFlower.png";

// Train icon component
const TrainIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="mx-auto"
  >
    <rect x="4" y="3" width="16" height="16" rx="2" />
    <path d="M4 11h16" />
    <path d="M12 3v8" />
    <circle cx="8" cy="15" r="1" />
    <circle cx="16" cy="15" r="1" />
    <path d="M8 19l-2 3" />
    <path d="M16 19l2 3" />
  </svg>
);

// Note/Document icon component
const NoteIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="mx-auto"
  >
    <rect x="5" y="3" width="14" height="18" rx="1" />
    <path d="M9 7h6" />
    <path d="M9 11h6" />
    <path d="M9 15h4" />
  </svg>
);

const TravelPage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const openDirections = (destination: string) => {
    const encodedDestination = encodeURIComponent(destination);
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${encodedDestination}`,
      "_blank"
    );
  };

  return (
    <section className="w-full bg-white py-16 md:py-24 px-6 relative">
      {/* Decorative floral elements - Right top (BEHIND content) */}
      <img
        src={rightFlower}
        alt=""
        className="absolute right-0 top-0 w-32 md:w-60 opacity-80 pointer-events-none z-0"
      />

      {/* Decorative floral elements - Left bottom (BEHIND content) */}
      <img
        src={leftFlower}
        alt=""
        className="absolute left-0 bottom-[0%] w-32 md:w-60 opacity-80 pointer-events-none z-0"
      />

      <div className="max-w-3xl mx-auto text-center">
        {/* Train - Ceremony Section */}
        <div data-aos="fade-up" className="mb-20">
          {/* Train Icon */}
          <div className="mb-4">
            <TrainIcon />
          </div>

          {/* Label */}
          <p className="text-gray-600 text-sm mb-2">Train</p>

          {/* Title */}
          <h2
            className="text-3xl md:text-5xl bg-gradient-to-r from-[#C49355] to-[#E8B46A] bg-clip-text text-transparent mb-4"
            // style={{
            //   fontFamily: "'Times New Roman', Times, serif",
            //   fontWeight: 400,
            //   fontStyle: "italic",
            // }}
          >
            Ceremony
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-6 max-w-xl mx-auto">
            The closest train station is Newbury Park, which is around a 7min
            walk from Elpis Christian Ministries
          </p>

          {/* View Button */}
          <button
            onClick={() =>
              openDirections(
                "Elpis Christian Ministries, 8 Oaks Lane, London, IG2 7PL"
              )
            }
            className="bg-[#3d3d3d] hover:bg-[#2d2d2d] text-white px-16 py-3 text-sm transition-colors duration-300"
          >
            View
          </button>
        </div>

        {/* Train - Reception Section */}
        <div data-aos="fade-up" data-aos-delay="150" className="mb-20">
          {/* Train Icon */}
          <div className="mb-4">
            <TrainIcon />
          </div>

          {/* Label */}
          <p className="text-gray-600 text-sm mb-2">Train</p>

          {/* Title */}
          <h2
            className="text-3xl md:text-5xl bg-gradient-to-r from-[#C49355] to-[#E8B46A] bg-clip-text text-transparent mb-4"
            // style={{
            //   fontFamily: "'Times New Roman', Times, serif",
            //   fontWeight: 400,
            //   fontStyle: "italic",
            // }}
          >
            Reception
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-6 max-w-xl mx-auto">
            The nearest station is Forest Gate which is on the Elizabeth Line.
          </p>

          {/* View Button */}
          <button
            onClick={() =>
              openDirections("Venue 254, 350 Katherine Road, London, E7 8NW")
            }
            className="bg-[#3d3d3d] hover:bg-[#2d2d2d] text-white px-16 py-3 text-sm transition-colors duration-300"
          >
            View
          </button>
        </div>

        {/* By Car Section */}
        <div data-aos="fade-up" data-aos-delay="300">
          {/* Note Icon */}
          <div className="mb-4">
            <NoteIcon />
          </div>

          {/* Label */}
          <p className="text-gray-600 text-sm mb-2">Travel Note</p>

          {/* Title */}
          <h2
            className="text-3xl md:text-5xl bg-gradient-to-r from-[#C49355] to-[#E8B46A] bg-clip-text text-transparent mb-4"
            // style={{
            //   fontFamily: "'Times New Roman', Times, serif",
            //   fontWeight: 400,
            //   fontStyle: "italic",
            // }}
          >
            By Car
          </h2>

          {/* Description */}
          <p className="text-gray-600 max-w-xl mx-auto">
            There are a lot of ways to get into East London! You can use the A12
            and connections such as M25, A406, A13. Waze and Google Maps will be
            your best friend!
          </p>
        </div>
      </div>
    </section>
  );
};

export default TravelPage;
